"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _NewbuildingReliabilityContext = require("./NewbuildingReliabilityContext");
Object.keys(_NewbuildingReliabilityContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NewbuildingReliabilityContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NewbuildingReliabilityContext[key];
    }
  });
});